
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';


const Home: React.FC = () => {
  useEffect(() => {
    // Dynamically add the EmbedSocial script
    const scriptId = 'EmbedSocialWidgetScript';
    if (!document.getElementById(scriptId)) {
      const js = document.createElement('script');
      js.id = scriptId;
      js.src = 'https://embedsocial.com/cdn/aht.js';
      document.head.appendChild(js);
    }
  }, []);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Premium Car Detailing
            <span className="hero-highlight"> Services</span>
          </h1>
          <p className="hero-description">
            Transform your vehicle with our professional detailing services. 
            We bring your car back to showroom condition with attention to every detail.
          </p>
          <div className="hero-actions">
            <Link to="/book" className="cta-button primary">
              Book Now
            </Link>
            <Link to="/services" className="cta-button secondary">
              View Services
            </Link>
          </div>
        </div>
        <div className="hero-image">
          <img src={process.env.PUBLIC_URL + '/exte.webp'} alt="Premium Exterior" className="hero-exterior-img" />
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Us?</h2>
          <div className="features-grid">
            <div className="features-left">
<div className="feature-card">
  <div className="feature-icon">✨</div>
  <h3>Premium Care</h3>
  <p>Your car receives the highest level of attention to keep it looking its absolute best.</p>
</div>
<div className="feature-card">
  <div className="feature-icon">⚡</div>
  <h3>Quick & Reliable</h3>
  <p>Detailing that respects your time while always delivering consistent results.</p>
</div>
<div className="feature-card">
  <div className="feature-icon">🎯</div>
  <h3>Detail Obsessed</h3>
  <p>Every curve, corner, and crevice of your vehicle is cared for with precision.</p>
</div>
<div className="feature-card">
  <div className="feature-icon">💎</div>
  <h3>Guaranteed Shine</h3>
  <p>Your satisfaction comes first we ensure a flawless finish every visit.</p>
</div>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Section (EmbedSocial) */}
      <section className="reviews">
        <div className="container">
          <h2 className="section-title">What Our Customers Say</h2>
          <div className="embedsocial-widget" data-ref="ec643b184cb034d3a89a00cefad0eed4">
            <a href="https://embedsocial.com/google-reviews-widget/" title="Add Google reviews on a website" target="_blank" rel="noreferrer noopener" className="powered-by-es es-slider">
              <img src="https://embedsocial.com/cdn/icon/embedsocial-logo.webp" alt="EmbedSocial" />
              <span> Google reviews widget </span>
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Detail Your Car?</h2>
          <p>Book your appointment today and experience the difference professional detailing makes.</p>
          <Link to="/book" className="cta-button primary large">
            Schedule Your Service
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;